module.exports = __webpack_public_path__ + "static/media/19.0ad738e9.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/19.JPG
// module id = 461
// module chunks = 0